import React, {useEffect, useState} from 'react'
import {BiAddToQueue} from 'react-icons/bi'
import {Link} from 'react-router-dom'
import LoadingTable from '../../../../components/UI/CardTables/LoadingTable'
import ErrorTable from '../../../../components/UI/CardTables/ErrorTable'
import {CardTables} from '../../../../components/UI/CardTables'
import {getLaunches} from '../../../../../services/urbit-gis'
import {RealEstateLaunch} from '../../../../../services/urbit-gis/types'
import {DateTimToView} from '../../../../components/util'
import {Buttons} from './Buttons'
import PaginationComponentGIS from '../../../../components/UI/PaginationComponentGis'
import {PageInfo} from '../../../../components/UI/PaginationComponents'

interface Props {
  filtro: any[] // Certifique-se de definir corretamente o tipo de 'filtro'
}

let cidades = []
cidades[3333] = 'Guaratuba'
cidades[4404] = 'Viamão'
cidades[4976] = 'Franco da Rocha'
cidades[5119] = 'Mauá'
cidades[4161] = 'Maquiné'
cidades[5132] = 'Mogi das Cruzes'
cidades[5222] = 'Piracicaba'
cidades[5321] = 'Santana de Parnaíba'
cidades[5323] = 'Santo André'
cidades[5335] = 'São Carlos'
cidades[4371] = 'Torres'
cidades[3661] = 'Rio de Janeiro'
cidades[3668] = 'São João de Meriti'
cidades[4908] = 'Carapicuíba'
cidades[4932] = 'Cotia'
cidades[4940] = 'Diadema'
cidades[4955] = 'Embu das Artes'
cidades[4969] = 'Ferraz de Vasconcelos'
cidades[5176] = 'Osasco'
cidades[5233] = 'Poá'
cidades[5333] = 'São Bernardo do Campo'
cidades[5334] = 'São Caetano do Sul'
cidades[5351] = 'São Paulo'
cidades[3198] = 'Almirante Tamandaré'
cidades[3256] = 'Campo Mourão'
cidades[5046] = 'Itapevi'
cidades[4450] = 'Barra Velha'
cidades[4454] = 'Biguaçu'
cidades[4530] = 'Imbituba'
cidades[4551] = 'Jaguaruna'
cidades[4609] = 'Penha'
cidades[4666] = 'São José'
cidades[3931] = 'Alvorada'
cidades[3999] = 'Canoas'
cidades[4002] = 'Capão da Canoa'
cidades[4101] = 'Gramado'
cidades[4211] = 'Osório'
cidades[5418] = 'Valinhos'
cidades[5372] = 'Sumaré'
cidades[4895] = 'Campinas'
cidades[3264] = 'Cascavel'
cidades[4416] = 'Xangri-lá'
cidades[3274] = 'Colombo'
cidades[3466] = 'Piraquara'
cidades[3254] = 'Campo Largo'
cidades[3278] = 'Contenda'
cidades[3305] = 'Fazenda Rio Grande'
cidades[3546] = 'São José dos Pinhais'
cidades[3289] = 'Curitiba'
cidades[4015] = 'Caxias do Sul'
cidades[2953] = 'Tamandaré'
cidades[4645] = 'Sangão'
cidades[3255] = 'Campo Magro'
cidades[5006] = 'Hortolândia'
cidades[4599] = 'Palhoça'
cidades[4685] = 'Tijucas'
cidades[4470] = 'Camboriú'
cidades[4444] = 'Balneário Camboriú'
cidades[4461] = 'Bombinhas'
cidades[4446] = 'Balneário Piçarras'
cidades[4587] = 'Navegantes'
cidades[4621] = 'Porto Belo'
cidades[4544] = 'Itajaí'
cidades[4545] = 'Itapema'
cidades[977] = 'Goiânia'
cidades[901] = 'Aparecida de Goiânia'
cidades[3217] = 'Araucária'
cidades[3387] = 'Londrina'
cidades[3212] = 'Apucarana'
cidades[4106] = 'Guaíba'
cidades[4104] = 'Gravataí'
cidades[3991] = 'Campo Bom'
cidades[3981] = 'Cachoeirinha'
cidades[4076] = 'Esteio'
cidades[4207] = 'Novo Hamburgo'
cidades[4318] = 'São Leopoldo'
cidades[4245] = 'Porto Alegre'
cidades[2897] = 'Olinda'
cidades[2918] = 'Recife'
cidades[4851] = 'Barueri'
cidades[898] = 'Anápolis'
cidades[3471] = 'Ponta Grossa'
cidades[3449] = 'Paranaguá'
cidades[3485] = 'Quatro Barras'
cidades[5001] = 'Guarulhos'
cidades[5053] = 'Itaquaquecetuba'
cidades[3412] = 'Matinhos'
cidades[3461] = 'Pinhais'
cidades[5352] = 'São Pedro'
cidades[4060] = 'Eldorado do Sul'
cidades[4506] = 'Florianópolis'
cidades[4224] = 'Passo Fundo'

export function TableAdminEmpreendimentos({filtro}: Props) {
  const [data, setData] = useState<RealEstateLaunch[]>([])
  const [pageInfo, setPageInfo] = useState<PageInfo>()
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [loading, setLoading] = useState<boolean>(false)
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [error, setError] = useState<string | null>(null)
  const [paginacao, setPaginacao] = useState({pagina: 1, quantidade: 10})

  async function fetchLaunches() {
    try {
      const launches = await getLaunches({
        page: paginacao.pagina,
        limit: paginacao.quantidade,
        filtro: {
          fields: filtro,
        },
      })

      // Ordenar os lançamentos pelo campo created_at em ordem decrescente
      const sortedLaunches = launches.data.sort((a, b) => {
        return new Date(b.created_at).getTime() - new Date(a.created_at).getTime()
      })

      setData(sortedLaunches)
      setPageInfo(launches.pagination)
    } catch (error) {
      console.error('Erro ao buscar lançamentos:', error)
    }
  }

  useEffect(() => {
    fetchLaunches()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [paginacao, filtro])

  const handleRefetch = () => {
    fetchLaunches()
  }

  function getCidade(id: number) {
    return cidades[id]
  }

  function getStatus(status) {
    switch (status) {
      case 1:
        return 'Publicado'
      case 2:
        return <span className='badge badge-info'>Em Edição</span>
      case 3:
        return <span className='badge badge-info'>Pendente Publicação</span>
      case 4:
        return <span className='badge badge-danger'>Descartado</span>
    }
  }
  return (
    <>
      <CardTables
        headerTitle={'Empreendimentos'}
        headerSubtTitle={`Listando ${paginacao.quantidade} empresas de ${
          pageInfo?.totalItems || 0
        }.`}
        headerToolbar={
          <Link
            to={'/backoffice/empreendimentos/create'}
            className='btn btn-light-primary btn-sm d-block me-2'
            style={{width: '100px !important'}}
          >
            <BiAddToQueue className='fs-2 me-1' />
            Criar Empreendimento
          </Link>
        }
        footer={
          <PaginationComponentGIS
            pagesInfo={pageInfo}
            setPagesInfo={(pagina: number, quantidade: number) => {
              setPaginacao({pagina: pagina, quantidade: quantidade})
            }}
          />
        }
      >
        <div className='table-responsive'>
          <table className='table table-striped table-row-dashed gy-2 gs-6 table-row-bordered table-hover table-row-gray-300 align-middle gs-0 gy-4'>
            <thead>
              <tr className='fw-bold fs-6 text-gray-800 border-bottom border-gray-200'>
                <th className='w-50px'></th>
                <th className='w-50px'>ID</th>
                <th className='min-w-140px'>Nome da Empreendimento</th>
                <th className='min-w-100px'>Endereço</th>
                <th className='min-w-100px'>Número</th>
                <th className='min-w-100px'>Bairro</th>
                <th className='min-w-100px'>Cidade</th>
                <th className='min-w-100px'>Situação Empreedimento</th>
                <th className='min-w-100px'>Status</th>
                <th className='min-w-180px'>Data de Lançamento</th>
                <th className='min-w-100px text-end'>Ação</th>
              </tr>
            </thead>
            <tbody>
              <LoadingTable loading={loading} />
              <ErrorTable error={error} />
              {data && data.length > 0 ? (
                data.map((response) => (
                  <tr key={response.id}>
                    <td>
                      {response ? (
                        response.origem === 'urbit' ? (
                          <img src='/media/logos/logo.png' alt='urbit' width={30} />
                        ) : (
                          <img src='/media/logos/orulo.svg' alt='órulo' width={30} />
                        )
                      ) : (
                        <></>
                      )}
                    </td>
                    <td>{response.id}</td>
                    <td>
                      <div className='d-flex align-items-center'>
                        <div className='d-flex justify-content-start flex-column'>
                          <span className='text-dark fw-bold d-block fs-6'>{response.name}</span>
                        </div>
                      </div>
                    </td>
                    <td>
                      <div className='d-flex align-items-center'>
                        <div className='d-flex justify-content-start flex-column'>
                          <span className='text-dark fw-bold d-block fs-6'>{response.address}</span>
                        </div>
                      </div>
                    </td>
                    <td>
                      <div className='d-flex align-items-center'>
                        <div className='d-flex justify-content-start flex-column'>
                          <span className='text-dark fw-bold d-block fs-6'>{response.number}</span>
                        </div>
                      </div>
                    </td>
                    <td>
                      <div className='d-flex align-items-center'>
                        <div className='d-flex justify-content-start flex-column'>
                          <span className='text-dark fw-bold d-block fs-6'>
                            {response.neighborhood}
                          </span>
                        </div>
                      </div>
                    </td>
                    <td>
                      <div className='d-flex align-items-center'>
                        <div className='d-flex justify-content-start flex-column'>
                          <span className='text-dark fw-bold d-block fs-6'>
                            {getCidade(response.id_city)}
                          </span>
                        </div>
                      </div>
                    </td>
                    <td>
                      <div className='d-flex align-items-center'>
                        <div className='d-flex justify-content-start flex-column'>
                          <span className='text-dark fw-bold d-block fs-6'>{response.status}</span>
                        </div>
                      </div>
                    </td>
                    <td>
                      <div className='d-flex align-items-center'>
                        <div className='d-flex justify-content-start flex-column'>
                          <span className='text-dark fw-bold d-block fs-6'>
                            {getStatus(response.id_status)}
                          </span>
                        </div>
                      </div>
                    </td>
                    <td>{DateTimToView(response.launch_date)}</td>
                    <td>
                      <Buttons handleRefetch={handleRefetch} id={response.id} />
                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan={12} className='text-center'>
                    Nenhum registro encontrado
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </CardTables>
    </>
  )
}
